import {Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IPortfolioResultResponse} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';

@Component({ standalone: false,
    selector: 'irb-dialog-pr-cost-basis',
    templateUrl: './dialog-pr-cost-basis.component.html',
    styleUrls: ['./dialog-pr-cost-basis.component.scss', '../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogPrCostBasisComponent implements OnInit {

    gridOptions: any;
    gridHeight: string = '140px';
    lotDataGrid: any = [];
    portfolioName: string = '';


    constructor(
        private dialogRef: MatDialogRef<DialogPrCostBasisComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Partial<IPortfolioResultResponse>
    ) {
    }

    ngOnInit(): void {
        const list: any[] = this.data.lotMismatchList || this.data.lotMissingCostBasisList || [];

        let o: any;
        list.forEach((item: any) => {
            o = {
                accountNumber: item.accNum || item.accountNum,
                symbol: item.secSymb || item.secSymbol,
                lotPurchaseDate: item.lotPurchaseDate
            };
            this.lotDataGrid.push(o);
        });

        let gridColumns: any = this.getColumns();
        if (this.data.lotMissingCostBasisList) {
            gridColumns.push(this.getLotPurchaseDateColumn());
        }

        this.gridOptions = {
            columnDefs: gridColumns,
            floatingFilter: false,
            domLayout: "autoHeight",
            overlayNoRowsTemplate: "<span></span>"
        };
        this.portfolioName = this.data.portfolioName;
    }

    private getColumns() {
        const columns: any = [
            {
                headerName: 'Acct #',
                field: 'accountNumber',
                minWidth: 120,
                editable: false,
                flex:1
            },
            {
                headerName: 'Security',
                field: 'symbol',
                minWidth: 130,
                editable: false,
                flex: 1
            }
        ];

        return columns;
    }

    private getLotPurchaseDateColumn() {
        return {
            headerName: 'Tax Lot Purchase Date',
            field: 'lotPurchaseDate',
            minWidth: 130,
            editable: false
        }
    }

    onGridReady(params: any) {
        //params.api.sizeColumnsToFit();

        if(this.lotDataGrid.length > 10) {
            params.api.setGridOption('domLayout', 'normal');
            this.gridHeight = "332px";
        } else if(this.lotDataGrid.length === 1) {
            params.api.setGridOption('domLayout', 'normal');
            this.gridHeight = "63px";
        } else {
            params.api.setGridOption('domLayout', 'autoHeight');
            this.gridHeight = "100%";
        }
        params.api.setGridOption('rowData', this.lotDataGrid);
    }

    close() {
        this.dialogRef.close();
    }
}
